import { FilledInputProps, InputAdornment, InputBaseComponentProps, InputProps, OutlinedInputProps, TextField } from "@mui/material"
import { InputHTMLAttributes } from "react"
import { twMerge } from "tailwind-merge"
import { useController, useForm } from "react-hook-form";

import Visibility from '@mui/icons-material/Visibility';

interface InputElementProps extends InputHTMLAttributes<HTMLInputElement> {
    value?: string
    inputProps?: InputBaseComponentProps,
    InputProps?: Partial<FilledInputProps> | Partial<OutlinedInputProps> | Partial<InputProps>
    borderRadius?: string;
    height?: string;
}

export function Element({ name, inputProps: props, InputProps, borderRadius = '8px', height = '45px', ...rest }: InputElementProps | any) {
    return (
        <TextField 
            id="outlined-basic" 
            variant="outlined"
            size="small"
            sx={{
                '& .MuiOutlinedInput-root': {
                    // borderRadius: borderRadius,
                    padding: 0,
                    lineHeight: 0,
                    // height: height
                },
                '& .MuiOutlinedInput-notchedOutline': {
                    // borderRadius: borderRadius,
                    borderColor: rest.error ? '#ED636E' : '',
                    // height: height
                },
            }}
            inputProps={props}
            className={twMerge("", rest.className)}
            InputProps={InputProps}
            {...rest}
        />
    )
}